import { ReactElement } from "react";
import { useFormContext } from "react-hook-form";

import { IntegrationMasterForm } from "../types/form-inputs.ts";
import { CardLayout } from "./CardLayout.tsx";
import InputFieldGroup from "./inputs/InputFieldGroup.tsx";

const OktaIntegrationDetails = (): null | ReactElement => {
  const methods = useFormContext<IntegrationMasterForm>();

  const {
    formState: { errors },
    register,
  } = methods;

  return (
    <>
      <CardLayout header={<>API Key</>}>
        <div className="mt-6 space-y-6">
          <div className="w-full">
            <InputFieldGroup<IntegrationMasterForm>
              errors={errors}
              fieldName="baseUrl"
              label="Base URL"
              placeHolder="https://miru.okta.com/api/v1/logs"
              register={register}
              rules={{
                required: "Please enter a Base URL",
              }}
              tooltip={{
                position: "right",
                text: "Enter the base endpoint URL for the API service",
              }}
              type="url"
            />
          </div>
          <div className="w-full">
            <InputFieldGroup<IntegrationMasterForm>
              errors={errors}
              fieldName="apiKey"
              label="API Key"
              placeHolder="MY_API_KEY"
              register={register}
              rules={{
                required: "Please enter an API Key",
              }}
              type="password"
            />
          </div>
        </div>
      </CardLayout>
    </>
  );
};

export default OktaIntegrationDetails;
